import { ViewHook } from "phoenix_live_view";

export default class extends ViewHook {
  static optionsSelector = '[data-hook="options"]';
  static inputSelector = '[data-hook="input"]';
  mounted() {
    // console.debug(`[SearchInput] ${this.el.id} mounted`);
    this.resizeOptions();
    this.input.addEventListener("blur", (event) => this.resetInput(event));
    this.input.addEventListener("focus", (event) => this.watchForClickAway(event));
    // TODO: Not sure yet how to handle this
    // this.handleEvent(`selected:${this.el.id}`, () => {
    //   console.debug(`[SearchInput] ${this.el.id} selected`);
    //   this.input.dispatchEvent(new Event("change", { bubbles: true }))
    // })
  }

  updated() {
    // console.debug(`[SearchInput] ${this.el.id} updated`);
    this.resizeOptions();
  }

  destroyed() {
    this.input.removeEventListener("blur", (event) => this.resetInput(event));
    this.input.removeEventListener("focus", (event) => this.watchForClickAway(event));
  }

  resizeOptions() {
    this.optionsElement = this.el.querySelector(this.constructor.optionsSelector);
    this.input = this.el.querySelector(this.constructor.inputSelector);
    if (this.optionsElement) {
      this.optionsElement.style.setProperty("--input-width", `${this.input.offsetWidth}px`);
    }
  }

  watchForClickAway(event) {
    this.optionsElement = this.el.querySelector(this.constructor.optionsSelector);
    if (this.optionsElement) {
      // console.debug(`[SearchInput] ${this.el.id} Setting click away`)
      window.addEventListener("click", (event) => this.removeOptions(event));
    }
  }

  resetInput(event) {
    // console.debug(`[SearchInput] ${this.el.id} called resetInput`)
    this.input.value = "";
  }

  removeOptions(event) {
    // console.debug(`[SearchInput] ${this.el.id} called removeOptions`)
    if (!this.optionsElement) return;
    // console.debug(`[SearchInput] ${this.el.id} has element`)
    if (this.el.contains(event.target)) return;
    // console.debug(`[SearchInput] ${this.el.id} contains target`)
    if (event.target.isConnected === false) return;
    // console.debug(`[SearchInput] ${this.el.id} is connected`)
    if (this.el.offsetWidth < 1 && el.offsetHeight < 1) return;
    // console.debug(`[SearchInput] ${this.el.id} is visible`)
    window.removeEventListener("click", (event) => this.removeOptions(event));
    this.pushEventTo(this.el, "reset", {});
  }
}
